import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Image from "@/components/common/Image";
import { styled } from "@mui/material/styles";
import { useBrandStore } from "./BrandProvider";
export const BrandBanner = ()=>{
    const { subjectTitle , bgImageUrl  } = useBrandStore((state)=>state.brand);
    return /*#__PURE__*/ _jsxs(BannerWrapper, {
        className: "brand-banner",
        children: [
            subjectTitle && /*#__PURE__*/ _jsx(Badge, {
                children: subjectTitle
            }),
            /*#__PURE__*/ _jsx(Image, {
                src: bgImageUrl,
                alt: "brand-banner",
                width: 1200,
                height: 240,
                defaultImage: "/static/images/brand_thumbnail_empty.jpg"
            })
        ]
    });
};
const BannerWrapper = styled("div")((param)=>{
    let { theme  } = param;
    return {
        width: "100%",
        minHeight: "120px",
        aspectRatio: "5 / 1",
        margin: "40px 0",
        position: "relative",
        overflow: "hidden",
        borderRadius: "12px",
        img: {
            height: "100%",
            width: "100%",
            objectFit: "cover",
            [theme.breakpoints.down("sm")]: {}
        },
        [theme.breakpoints.down("lg")]: {
            margin: "32px 0"
        },
        [theme.breakpoints.down("sm")]: {
            margin: "0 0 28px",
            borderRadius: "0"
        }
    };
});
const Badge = styled("p")((param)=>{
    let { theme  } = param;
    return {
        position: "absolute",
        top: 16,
        left: 16,
        boxShadow: theme.shadows[2],
        padding: "4px 12px",
        borderRadius: "40px",
        color: theme.palette.text.primary,
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        ...theme.typography.subtitle2
    };
});
